import React, { createContext, useState, useContext } from 'react';
import API_BASE_URL from '../config';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  // Hydrate synchronously: an effect runs AFTER the first render, so the
  // /admin route guard would bounce an authed reload to /login before the
  // saved session loaded (F5 on /admin looked like a logout).
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => !!localStorage.getItem('adminChannelUrl'));
  const [channelUrl, setChannelUrl] = useState(
    () => localStorage.getItem('adminChannelUrl') || '');
  const [customerKey, setCustomerKey] = useState(
    () => localStorage.getItem('adminCustomerKey') || '');

  const login = async (url, key) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/channel-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ channel_url: url, customer_key: key }),
      });
      if (response.ok) {
        localStorage.setItem('adminChannelUrl', url);
        localStorage.setItem('adminCustomerKey', key);
        setChannelUrl(url);
        setCustomerKey(key);
        setIsAuthenticated(true);
        return true;
      }
    } catch (e) {
      // network error — fall through
    }
    return false;
  };

  const logout = () => {
    localStorage.removeItem('adminChannelUrl');
    localStorage.removeItem('adminCustomerKey');
    setChannelUrl('');
    setCustomerKey('');
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, channelUrl, customerKey, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};